module.exports = __webpack_public_path__ + "static/media/icon-error-search-properties.8f6ae02f.svg";